import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/core/service/base-service';
import { FunnelModal } from '../modal/funnel-modal';
import { Observable } from 'rxjs';
import { ResponseData } from 'src/app/core/modal/base-save-update-response';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { AuthUtilsService } from 'src/app/core/util/auth-utils.service';
import { FunnelStageModel } from '../../funnel-stage/model/funnel-stage-model';
import { FunnelTypeModel } from '../../funnel-type/model/funnel-type-model';
import { PaginationData } from '../../../core/modal/pagination-data';
import { OrderingData } from '../../../core/modal/ordering-data';
import { FunnelHistory } from '../modal/funnel-history';
import { DigitalplatformModal } from '../../digitalplatform/modal/digitalplatform-modal';
import { SearchData } from '../../../core/modal/search-data';

@Injectable({
  providedIn: 'root',
})
export class FunnelServiceService extends BaseService<FunnelModal> {
  serverFilterObj: SearchData[] = [];
  constructor(http: HttpClient, authService: AuthUtilsService) {
    super(http, authService);
  }
  getModuleName(): string {
    return 'crm/funnel';
  }
  getServerFilterObj() {
    return this.serverFilterObj;
  }
  setServerFilterObj(filters: SearchData[]) {
    let filterObj = JSON.parse(JSON.stringify(filters));

    if (filterObj && filterObj.length > 0) {
      if (this.serverFilterObj && this.serverFilterObj.length > 0)
        filterObj.map((fObj) => {
          let objIndex = this.serverFilterObj.findIndex(function (obj) {
            return obj.filterColumn == fObj.filterColumn;
          });
          if (objIndex != -1) {
            this.serverFilterObj[objIndex] = fObj;
          } else {
            this.serverFilterObj.push(fObj);
          }
        });
      else {
        this.serverFilterObj = filterObj;
      }
    } else {
      if (this.serverFilterObj && this.serverFilterObj.length > 0) {
        let serverFilterObj = JSON.parse(JSON.stringify(this.serverFilterObj));
        serverFilterObj = this.serverFilterObj.filter((fObj) => {
          return fObj.filterColumn == 'any';
        });
        this.serverFilterObj = serverFilterObj;
      }
    }
    return this.serverFilterObj;
  }
  validate(): boolean {
    return true;
  }
  public getFunnelById(id): Observable<ResponseData<FunnelModal>> {
    return this.http.get<ResponseData<FunnelModal>>(environment.SERVER_URL + 'crm/funnel/' + id);
  }
  public getProjectStageList(): Observable<ResponseData<FunnelStageModel>> {
    return this.http.get<ResponseData<FunnelStageModel>>(environment.SERVER_URL + 'crm/funnelStage/getAllByPartner');
  }

  public getFunnelTypeLists(): Observable<ResponseData<FunnelTypeModel>> {
    return this.http.get<ResponseData<FunnelTypeModel>>(environment.SERVER_URL + 'crm/funnelType');
  }

  public downloadFile(fileName): Observable<any> {
    return this.http.get<any>(environment.DOWNLOAD_GET_FILE + fileName);
  }
  public getAll(paginationData: PaginationData, orderingData: OrderingData): Observable<ResponseData<FunnelModal>> {
    return this.http.get<ResponseData<FunnelModal>>(environment.SERVER_URL + 'crm/funnel/getFunnelByLoggedInUser');
  }
  // public getAll(param): Observable<ResponseData<FunnelModal>> {
  //   return this.http.post<ResponseData<FunnelModal>>(environment.SERVER_URL + 'crm/funnel/getFunnelByLoggedInUser',param);
  // }

  public editStageName(data: FunnelStageModel): Observable<ResponseData<FunnelStageModel>> {
    return this.http.post<ResponseData<FunnelStageModel>>(environment.SERVER_URL + 'crm/funnelStage/update', data);
  }

  public getFunnelHistory(): Observable<ResponseData<FunnelHistory>> {
    return this.http.get<ResponseData<FunnelHistory>>(environment.SERVER_URL + 'crm/funnelHistory');
  }

  onFunnelReject(data: DigitalplatformModal): Observable<ResponseData<DigitalplatformModal>> {
    return this.http.post<ResponseData<DigitalplatformModal>>(
      environment.SERVER_URL + 'crm/funnelindiamart/reject',
      data
    );
  }

  getItemById(id: number): Observable<ResponseData<any>> {
    return this.http.get<ResponseData<any>>(environment.SERVER_URL + 'chemical/item/getWithProperties/' + id);
  }

  public getFunnelNumber(): Observable<ResponseData<string>> {
    return this.http.get<ResponseData<string>>(environment.SERVER_URL + this.getModuleName() + '/getFunnelUniqueID');
  }
}
